module.exports = __webpack_public_path__ + "img/bank-12-kn.3cfca22e.svg";